<template>
  <main class="organism-create-new-incident">
    <section name="header">
      <label class="header__container header__text--topic"
        >Create New Incident / Job</label
      >
    </section>

    <!-- Ticket Detail Start-->
    <section name="ticket-detail">
      <hr />
      <div class="card-padding">
        <label class="text-size-16">Ticket Classification</label>
        <div class="input-container mt-1">
          <atom-select
            v-model="ticketDetail.site"
            title="Site"
            placeholder="Select Site"
            label="name"
            :isAsterisk="true"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isClearable="false"
            :isSearchable="false"
            :option="siteOptionList"
            :isError="isErrorTicketDetail.site"
            :errorMessage="errorMessageTicketDetail.site"
            @onUpdateSelectedValue="onSelectSite"
          ></atom-select>
        </div>
        <div class="d-xl-flex mt-1">
          <div class="ticket-detail__department-priority">
            <div class="ticket-detail__department input-container">
              <atom-select
                v-model="ticketDetail.department"
                title="Department"
                placeholder="Select Department"
                label="name"
                :isAsterisk="true"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :isSearchable="false"
                :option="departmentList"
                :isError="isErrorTicketDetail.department"
                :errorMessage="errorMessageTicketDetail.department"
              ></atom-select>
            </div>
            <div class="ticket-detail__priority input-container">
              <atom-select
                v-model="ticketDetail.priority"
                title="Priority"
                placeholder="Select Priority"
                label="name"
                :isAsterisk="true"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isClearable="false"
                :isSearchable="false"
                :option="priorityList"
                :isError="isErrorTicketDetail.priority"
                :errorMessage="errorMessageTicketDetail.priority"
              ></atom-select>
            </div>
          </div>
          <div class="ticket-detail__source input-container">
            <atom-select
              v-model="ticketDetail.source"
              title="Source"
              placeholder="Select Source"
              label="name"
              :isAsterisk="true"
              :isAppendToBody="false"
              :isEnableProper="false"
              :isClearable="false"
              :isSearchable="false"
              :option="sourceList"
              :isError="isErrorTicketDetail.source"
              :errorMessage="errorMessageTicketDetail.source"
            ></atom-select>
          </div>
        </div>
      </div>
    </section>
    <!-- Ticket Detail End-->

    <!-- Customer Start-->
    <section name="customer">
      <hr />
      <div class="card-padding">
        <label class="text-size-16">Reporter Details</label>
        <div class="ticket__type mt-1">
          <div class="input-container">
            <atom-select
              v-model="selectedTicketType"
              title="Ticket Type"
              placeholder="Select Ticket Type"
              :isAsterisk="true"
              :isAppendToBody="false"
              :isEnableProper="false"
              :isClearable="false"
              :option="ticketTypeOption"
              @change="onChangeTicketType"
            ></atom-select>
          </div>
        </div>
        <div class="customer__detail">
          <div class="customer__name input-container">
            <atom-input
              v-model="customer.name"
              title="Customer Name"
              placeholder="Customer Name"
              :isAsterisk="true"
              :isDisable="false"
              :isError="isErrorCustomer.name"
              :errorMessage="errorMessageCustomer.name"
            ></atom-input>
          </div>
          <div class="customer__contact">
            <div class="customer__email input-container">
              <atom-input
                v-model="customer.email"
                title="Email"
                placeholder="Email"
                :isAsterisk="true"
                :isDisable="false"
                :isError="isErrorCustomer.email"
                :errorMessage="errorMessageCustomer.email"
              ></atom-input>
              <!-- <atom-checkbox
                v-model="isSentEmailToUser"
                title="Send email to user"
                class="customer__email--checkbox"
              ></atom-checkbox> -->
            </div>
            <div class="customer__phone input-container">
              <atom-input
                v-model="customer.phone"
                title="Phone Number"
                placeholder="Phone Number"
                :isAsterisk="true"
                :isDisable="false"
                :isError="isErrorCustomer.phone"
                :errorMessage="errorMessageCustomer.phone"
              ></atom-input>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- customer End-->

    <!-- Ticket Start-->
    <section name="ticket">
      <hr />
      <div class="ticket__container">
        <label class="text-size-16">Ticket Detail</label>
        <div class="ticket__topic input-container mt-1">
          <atom-select
            v-model="ticket.topic"
            title="Topic"
            placeholder="Select Topic"
            label="name"
            :isAsterisk="true"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isClearable="false"
            :isSearchable="false"
            :option="topicList"
            :isError="isErrorTicket.topic"
            :errorMessage="errorMessageTicket.topic"
          ></atom-select>
        </div>
        <div class="ticket__subject input-container">
          <atom-input
            v-model="ticket.subject"
            title="Topic Subject"
            placeholder="Subject"
            :isAsterisk="true"
            :isDisable="false"
            :isError="isErrorTicket.subject"
            :errorMessage="errorMessageTicket.subject"
          ></atom-input>
        </div>
        <div class="ticket__detail input-container">
          <atom-text-area
            v-model="ticket.detail"
            title="Topic Detail"
            placeholder="Detail"
            :isAsterisk="true"
            :isDisable="false"
            :isError="isErrorTicket.detail"
            :errorMessage="errorMessageTicket.detail"
            :isResizable="true"
          ></atom-text-area>
        </div>
        <div class="ticket__attachments">
          <atom-file-attachment-input
            id="internalCreateNewIncidentAttachment"
            title="Attachments (Max. 25Mb)"
            @onUpdateFile="onUpdateIncidentAttachment"
          ></atom-file-attachment-input>
        </div>
      </div>
    </section>
    <!-- Ticket End-->

    <section name="escalation">
      <hr />
      <div class="p-2">
        <molecule-escalation-selection
          v-model="escalationSelected"
          :escalation-template-list="escalationTemplateList"
          :escalation-name="escalationDetail.name"
          :description="escalationDetail.description"
          :levels="escalationDetail.levels"
          :is-show-info="true"
          :is-disable-select="!hasReadTicketEscalationPermission"
        />
      </div>
    </section>

    <!-- Button Start-->
    <section name="button">
      <div class="button__container w-100">
        <div class="button__create">
          <atom-button
            buttonId="button__create"
            :isDisable="isDisableButton"
            @click="onClickCreateNewIncident"
            >Create {{ selectedTicketType.label }}
          </atom-button>
        </div>
        <div class="button__cancel">
          <atom-button
            buttonId="button__cancel"
            buttonStyle="border"
            buttonColor="secondary"
            @click="onClickCancel"
            >Cancel</atom-button
          >
        </div>
      </div>
    </section>
    <!-- Button End-->

    <!-- Modal Start-->
    <section name="modal">
      <molecule-modal-dialog
        modalId="create-incident__confirm-create"
        :isTextCenter="true"
        :textTitle="`Do you want to create\n“${ticket.subject}” ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmCreate"
      ></molecule-modal-dialog>
      <molecule-modal-dialog
        modalId="create-incident__confirm-cancel"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmCancel"
      ></molecule-modal-dialog>
    </section>
    <!-- Modal End-->
  </main>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomFileAttachmentInput from "@/components/atoms/AtomFileAttachmentInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeEscalationSelection from "@/components/molecules/portal/escalationSelection/MoleculeEscalationSelection.vue"
import { TicketType, TicketTypeLabel } from "@/constants"
import { mapGetters } from "vuex"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismTicketCreateNewIncident",
  components: {
    AtomSelect,
    AtomInput,
    AtomTextArea,
    AtomFileAttachmentInput,
    AtomButton,
    MoleculeModalDialog,
    MoleculeEscalationSelection,
  },
  props: {
    departmentList: {
      type: Array,
      required: true,
    },
    priorityList: {
      type: Array,
      required: true,
    },
    sourceList: {
      type: Array,
      required: true,
    },
    topicList: {
      type: Array,
      required: true,
    },
    // customerData: {
    //   type: Object,
    //   required: false,
    //   default: null,
    // },
    ticketData: {
      type: Object,
      required: false,
      default: null,
    },
    // escalation
    escalationTemplateList: {
      type: Array,
      required: true,
    },
    escalation: {
      type: Object,
      required: false,
      default: () => {},
    },
    escalationDetail: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mixins: [mixinsValidator, mixinsUser],
  emits: [
    "selectedTopicId",
    "createIncidentOrJob",
    "onSelectSite",
    "changeEscalationTemplate",
  ],
  data() {
    return {
      // validate
      isValidate: false,
      isError: false,

      // modal
      modalId: null,

      // customer
      customer: {
        name: null,
        email: null,
        phone: null,
      },
      // isSentEmailToUser: false,
      isErrorCustomer: {
        idcId: false,
        name: false,
        email: false,
        phone: false,
      },
      errorMessageCustomer: {
        idcId: null,
        name: null,
        email: null,
        phone: null,
      },

      // ticket-detail
      ticketDetail: {
        department: null,
        priority: null,
        source: null,
        site: null,
      },
      isErrorTicketDetail: {
        department: false,
        priority: false,
        source: false,
        site: false,
      },
      errorMessageTicketDetail: {
        department: null,
        priority: null,
        source: null,
        site: null,
      },

      // ticket
      selectTopicId: null,
      ticket: {
        topic: null,
        subject: null,
        detail: null,
        attachments: null,
      },
      isErrorTicket: {
        topic: false,
        subject: false,
        detail: false,
      },
      errorMessageTicket: {
        topic: null,
        subject: null,
        detail: null,
      },
      selectedTicketType: {
        label: TicketTypeLabel.JOB,
        value: TicketType.JOB,
      },
      ticketTypeOption: [
        { label: TicketTypeLabel.JOB, value: TicketType.JOB },
        { label: TicketTypeLabel.INCIDENT, value: TicketType.INCIDENT },
      ],

      siteOptionList: [],
    }
  },
  computed: {
    ...mapGetters("siteStore", ["siteSetting", "siteOptions"]),

    isDisableButton() {
      return this.isValidate && this.isError
    },

    hasReadTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_READ)
    },

    escalationSelected: {
      get() {
        return this.escalation
      },
      set(newValue) {
        this.$emit("changeEscalationTemplate", newValue)
      },
    },
  },
  watch: {
    siteSetting() {
      this.getSiteOptions()
      this.ticketDetail.site = null
      this.ticketDetail.department = null
    },
    customer: {
      deep: true,
      handler() {
        if (this.isValidate) this.validate()
      },
    },
    ticketDetail: {
      deep: true,
      handler() {
        if (this.isValidate) this.validate()
      },
    },
    ticket: {
      deep: true,
      handler() {
        if (this.ticket.topic?.id) this.getTicketData()

        if (this.isValidate) this.validate()
      },
    },
    ticketData: {
      deep: true,
      handler() {
        if (this.ticketData) {
          this.ticket = {
            ...this.ticketData,
          }
        }

        if (this.isValidate) this.validate()
      },
    },
  },
  mounted() {
    this.getSiteOptions()
    // we use fixed data instead
    // this.customer = this.customerData
    this.ticketDetail = {
      department: null,
      priority: this.priorityList.find((p) => p.id === "MEDIUM"),
      source: this.sourceList.find((s) => s.id === "TICKET"),
    }
  },
  methods: {
    async getSiteOptions() {
      this.siteOptionList = this.siteOptions.map((site) => {
        return {
          id: site.value,
          name: site.text,
        }
      })
    },
    // get ticket data
    getTicketData() {
      if (!this.selectTopicId || this.selectTopicId !== this.ticket.topic.id) {
        this.selectTopicId = this.ticket.topic.id
        this.$emit("selectedTopicId", this.selectTopicId)
      }
    },

    // click button
    onClickCreateNewIncident() {
      this.isValidate = true
      this.validate()
      if (this.isValidate && !this.isError)
        this.openModal("create-incident__confirm-create")
    },
    clickConfirmCreate() {
      const createTicket = {
        ticketType: this.selectedTicketType.value,
        topicId: this.selectTopicId,
        ticketSubject: this.ticket.subject,
        ticketDetail: this.ticket.detail,
        priority: this.ticketDetail.priority.id,
        source: this.ticketDetail.source.id,
        responsibleDepartment: this.ticketDetail.department.id,
        contractCustomerName: this.customer?.name,
        contractEmails: this.getCustomerEmail(),
        contractPhones: this.customer.phone,
        siteId: this.ticketDetail?.site?.id,
        escalationId: this.escalationSelected?.escalationId || null,
        // sendEmailToUser: this.isSentEmailToUser,
      }
      const uploadAttachment = this.ticket.attachments      
      this.$emit("createIncidentOrJob", createTicket, uploadAttachment)
      this.closeModal()
    },

    getCustomerEmail() {
      return this.customer.email
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email.length > 0)
        .join(",")
    },

    onClickCancel() {
      this.openModal("create-incident__confirm-cancel")
    },

    clickConfirmCancel() {
      this.$router.push({ name: "internalTicketManagement" })
    },

    // modal
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    // validate
    validate() {
      const isErrorCustomer = this.validateCustomer()
      const isErrorTicketDetail = this.validateTicketDetail()
      const isErrorTicket = this.validateTicket()
      this.isError = isErrorCustomer || isErrorTicketDetail || isErrorTicket
    },

    validateCustomer() {
      // name
      if (!this.customer?.name) {
        this.isErrorCustomer.name = true
        this.errorMessageCustomer.name = "Please enter customer name"
      } else {
        this.isErrorCustomer.name = false
        this.errorMessageCustomer.name = null
      }
      // email
      const emailRegEx = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (!this.customer.email) {
        this.isErrorCustomer.email = true
        this.errorMessageCustomer.email = "Please enter email"
      } else if (this.validateByRegEx(emailRegEx, this.customer.email)) {
        this.isErrorCustomer.email = true
        this.errorMessageCustomer.email = "Please enter valid email"
      } else {
        this.isErrorCustomer.email = false
        this.errorMessageCustomer.email = null
      }
      // phone
      // const phoneRegEx = /^(\+66|0)[0-9]{8,9}$/
      if (!this.customer.phone) {
        this.isErrorCustomer.phone = true
        this.errorMessageCustomer.phone = "Please enter phone"
      }
      // else if (this.validateByRegEx(phoneRegEx, this.customer.phone)) {
      //   this.isErrorCustomer.phone = true
      //   this.errorMessageCustomer.phone = "Please enter valid phone"
      // }
      else {
        this.isErrorCustomer.phone = false
        this.errorMessageCustomer.phone = null
      }
      return (
        this.isErrorCustomer.name ||
        this.isErrorCustomer.email ||
        this.isErrorCustomer.phone
      )
    },

    validateTicketDetail() {
      // department
      if (!this.ticketDetail.department) {
        this.isErrorTicketDetail.department = true
        this.errorMessageTicketDetail.department = "Please select department"
      } else {
        this.isErrorTicketDetail.department = false
        this.errorMessageTicketDetail.department = null
      }
      // priority
      if (!this.ticketDetail.priority) {
        this.isErrorTicketDetail.priority = true
        this.errorMessageTicketDetail.priority = "Please select priority"
      } else {
        this.isErrorTicketDetail.priority = false
        this.errorMessageTicketDetail.priority = null
      }
      // source
      if (!this.ticketDetail.source) {
        this.isErrorTicketDetail.source = true
        this.errorMessageTicketDetail.source = "Please select source"
      } else {
        this.isErrorTicketDetail.source = false
        this.errorMessageTicketDetail.source = null
      }

      if (!this.ticketDetail.site) {
        this.isErrorTicketDetail.site = true
        this.errorMessageTicketDetail.site = "Please select site"
      } else {
        this.isErrorTicketDetail.site = false
        this.errorMessageTicketDetail.site = null
      }
      return (
        this.isErrorTicketDetail.department ||
        this.isErrorTicketDetail.priority ||
        this.isErrorTicketDetail.source ||
        this.isErrorTicketDetail.site
      )
    },

    validateTicket() {
      // topic
      if (!this.ticket.topic) {
        this.isErrorTicket.topic = true
        this.errorMessageTicket.topic = "Please select topic"
      } else {
        this.isErrorTicket.topic = false
        this.errorMessageTicket.topic = null
      }
      // subject
      if (!this.ticket.subject || this.isEmptyString(this.ticket.subject)) {
        this.isErrorTicket.subject = true
        this.errorMessageTicket.subject = "Please enter subject"
      } else {
        this.isErrorTicket.subject = false
        this.errorMessageTicket.subject = null
      }
      // detail
      if (!this.ticket.detail || this.isEmptyString(this.ticket.detail)) {
        this.isErrorTicket.detail = true
        this.errorMessageTicket.detail = "Please enter detail"
      } else {
        this.isErrorTicket.detail = false
        this.errorMessageTicket.detail = null
      }
      return (
        this.isErrorTicket.topic ||
        this.isErrorTicket.subject ||
        this.isErrorTicket.detail
      )
    },

    validateByRegEx(regEx, textWithComma) {
      let isError = false
      const texts = textWithComma.split(",")
      texts.forEach((text) => {
        if (!regEx.test(text.replace(/\s/g, ""))) isError = true
      })
      return isError
    },

    onUpdateIncidentAttachment(fileList) {
      this.ticket.attachments = fileList
    },

    onSelectSite() {
      this.$emit("onSelectSite", this.ticketDetail?.site?.id)
      this.ticketDetail.department = null
      this.setIncidentOrJobDefaultInfo()
    },

    setIncidentOrJobDefaultInfo() {
      if (this.selectedTicketType.label === TicketTypeLabel.JOB) {
        switch (this.ticketDetail?.site?.name) {
          case "Nonthaburi 1":
          case "Nonthaburi 2":
            this.customer = {
              name: "Support Nonthaburi",
              email: "job_non@ntdatacenter.net",
              phone: "02-104-7454",
            }
            return
          case "Sriracha":
            this.customer = {
              name: "Support Sriracha",
              email: "job_sri@ntdatacenter.net",
              phone: "081-352-0336",
            }
            return
          case "THAILAND IX":
            this.customer = {
              name: "THIX NOC",
              email: "job@th-ix.net",
              phone: "021042372",
            }
            return
          default:
            this.customer = {
              name: "Support Bangrak",
              email: "job@ntdatacenter.net",
              phone: "02-104-1431",
            }
            return
        }
      } else {
        switch (this.ticketDetail?.site?.name) {
          case "Nonthaburi 1":
          case "Nonthaburi 2":
            this.customer = {
              name: "Support Nonthaburi",
              email: "job_non@ntdatacenter.net",
              phone: "02-104-7454",
            }
            return
          case "Sriracha":
            this.customer = {
              name: "Support Sriracha",
              email: "job_sri@ntdatacenter.net",
              phone: "081-352-0336",
            }
            return
          case "THAILAND IX":
            this.customer = {
              name: "THIX NOC",
              email: "job@th-ix.net",
              phone: "021042372",
            }
            return
          default:
            this.customer = {
              name: "Support Bangrak",
              email: "job@ntdatacenter.net",
              phone: "02-104-1431",
            }
            return
        }
      }
    },

    onChangeTicketType() {
      if (this.ticketDetail.site) {
        this.setIncidentOrJobDefaultInfo()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-create-new-incident {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

section[name="header"] {
  .header__container {
    margin: 21px;
  }

  .header__text--topic {
    font-weight: 500;
    font-size: 18px;
  }
}

section[name="customer"] {
  .customer__container {
    padding: 0 21px 21px 21px;
  }

  .customer__detail {
    margin: 1rem 0 0 0;
  }

  .customer__email {
    margin: 1rem 0 0 0;
  }

  .customer__email--checkbox {
    margin: 8px 0 0 0;
  }

  .customer__phone {
    margin: 1rem 0 0 0;
  }

  @media screen and (min-width: 768px) {
    .customer__contact {
      display: flex;
    }

    .customer__phone {
      margin: 1rem 0 0 15px;
    }
  }

  @media screen and (min-width: 1200px) {
    .customer__detail {
      margin-top: 1rem;
      display: flex;
    }

    .customer__email,
    .customer__phone {
      margin: 0 0 0 15px;
    }
  }
}

section[name="ticket-detail"] {
  .ticket-detail__container {
    padding: 21px;
  }

  .ticket-detail__priority {
    margin: 1rem 0 0 0;
  }

  .ticket-detail__source {
    margin: 1rem 0 0 0;
  }

  @media screen and (min-width: 768px) {
    .ticket-detail__department-priority {
      display: flex;
    }

    .ticket-detail__priority {
      margin: 0 0 0 15px;
    }

    .ticket-detail__source {
      margin: 1rem 0 0 0;
    }
  }

  @media screen and (min-width: 1200px) {
    .ticket-detail__priority,
    .ticket-detail__source {
      margin: 0 0 0 15px;
    }
  }
}

section[name="ticket"] {
  .ticket__container {
    padding: 21px 21px 21px 21px;
  }

  .ticket__subject,
  .ticket__detail {
    margin: 1rem 0 0 0;
  }

  .ticket__attachments {
    margin: 1rem 0 0 0;
  }
}

section[name="button"] {
  .button__container {
    display: flex;
    justify-content: flex-end;
    padding: 21px 21px 42px 21px;
  }

  .button__cancel {
    margin: 0 0 0 16px;
  }
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.input-container {
  width: 100%;
}

.input-container-small {
  width: 75px;
}

.text__topic {
  color: #5e5873;
  font-weight: 500;
  font-size: 21px;
}

.icon__size {
  width: 80px;
  height: 80px;
  margin-top: 16px;
  margin-bottom: 18px;
}

@media screen and (min-width: 768px) {
  .input-container {
    width: 325px;
  }
}

@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}
</style>
